import { setCookie, getCookie } from '../utils/cookies';
import Hammer from 'hammerjs';
import gsap from 'gsap';

const selectors = {
  modal: '#modal-notifications',
  notification: '.js-notification',
  closeBtn: '.js-notification-close',
  notificationsBtn: '.js-notifications-btn',
};

const classes = {
  disabled: 'is-disabled',
};

const init = () => {
  const modal = document.querySelector(selectors.modal);
  if (!modal) return;
  const notifications = modal.querySelectorAll(selectors.notification);
  const notificationsBtn = document.querySelector(selectors.notificationsBtn);
  if (!notifications.length || !notificationsBtn) return;
  const notificationsCountEl = notificationsBtn.querySelector('.js-notifications-qty');
  let notificationsCount = parseInt(notificationsCountEl.textContent, 10);

  const updateNotificationsCount = () => {
    notificationsCount = parseInt(notificationsCountEl.textContent, 10);
    if (notificationsCount > 1) {
      notificationsCountEl.textContent = notificationsCount - 1;
      notificationsBtn.classList.remove(classes.disabled);
    } else {
      notificationsCountEl.textContent = 0;
      notificationsBtn.classList.add(classes.disabled);
      modal.modal.closeModal();
     }
  };

  const closeNotification = (notification, direction = 1) => {
    const tl = gsap.timeline();
    tl.to(notification, {
      x: direction * notification.offsetWidth,
      opacity: 0,
      duration: 0.3,
    }).to(notification, {
      height: 0,
      padding: 0,
      margin: 0,
      borderWidth: 0,
      duration: 0.3,
      onComplete: () => {
        notification.remove();
        setCookie('notif-' + notification.id, 'closed', 1);
        updateNotificationsCount();
      },
    });
  };

  notifications.forEach((notification, i) => {
    const hammer = new Hammer(notification);
    const closeBtn = notification.querySelector(selectors.closeBtn);

    if (getCookie('notif-' + notification.id) === 'closed') {
      notification.remove();
      updateNotificationsCount();
      return;
    }

    if (i === notifications.length - 1 && notificationsCount > 0) {
      setTimeout(() => {
        modal.modal.openModal();
      }, 60000);
    }

    hammer.on('panmove', e => {
      const distance = Math.abs(e.deltaX) / notification.offsetWidth;
      gsap.set(notification, {
        x: e.deltaX,
        opacity: 1 - distance,
      });
    });

    hammer.on('panend', e => {
      const threshold = notification.offsetWidth * 0.3;
      if (Math.abs(e.deltaX) > threshold) {
        const direction = e.deltaX > 0 ? 1 : -1;
        closeNotification(notification, direction);
      } else {
        gsap.to(notification, { x: 0, opacity: 1, duration: 0.3 });
      }
    });

    closeBtn.addEventListener('click', () => {
      closeNotification(notification);
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
